var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ArrowOutwardRoundedIcon from "@mui/icons-material/ArrowOutwardRounded";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Link as RouterLink, Navigate, useNavigate } from "react-router-dom";
import { getApiErrorMessage } from "../../../apis/http";
import { useAuth } from "../AuthContext";
import { getDefaultHomePath } from "../../router/routes";
var pageContent = {
    login: {
        actionLabel: "Entrar com Smartpass",
        description: "A autenticacao do ParticiPE agora e centralizada no Smartpass. Depois do login, o frontend consulta `/my-profile` para carregar seu papel real salvo no banco local.",
        eyebrow: "Entrada Smartpass",
        helper: "Se o redirecionamento automatico nao acontecer, use o botao abaixo para abrir a autenticacao.",
        title: "Acessar sua area",
    },
    register: {
        actionLabel: "Criar acesso no Smartpass",
        description: "O cadastro legado foi substituido pelo fluxo de registro centralizado do Smartpass. Assim que o token voltar, o backend cria ou atualiza seu perfil local automaticamente.",
        eyebrow: "Cadastro Smartpass",
        helper: "Se o redirecionamento automatico nao acontecer, use o botao abaixo para iniciar o cadastro.",
        title: "Criar ou vincular acesso",
    },
};
var SmartpassActionPage = function (_a) {
    var mode = _a.mode;
    var _b = useAuth(), hasPortalConnect = _b.hasPortalConnect, initialized = _b.initialized, isAuthenticated = _b.isAuthenticated, isLoadingAuth = _b.isLoadingAuth, login = _b.login, profileError = _b.profileError, register = _b.register, role = _b.role;
    var _c = useState(null), actionError = _c[0], setActionError = _c[1];
    var _d = useState(false), submitting = _d[0], setSubmitting = _d[1];
    var content = pageContent[mode];
    var action = useMemo(function () { return (mode === "login" ? login : register); }, [login, mode, register]);
    var handleAction = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setActionError(null);
                    if (!hasPortalConnect) {
                        setActionError("O Smartpass nao esta disponivel neste contexto. Abra esta aplicacao pelo portal ou tente novamente em um ambiente com Webgate ativo.");
                        return [2 /*return*/];
                    }
                    setSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, action()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    setActionError(getApiErrorMessage(error_1));
                    return [3 /*break*/, 5];
                case 4:
                    setSubmitting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [action, hasPortalConnect]);
    if (!initialized || isLoadingAuth) {
        return (_jsx(Paper, __assign({ sx: {
                borderRadius: 6,
                overflow: "hidden",
                p: { xs: 3, md: 4 },
            } }, { children: _jsxs(Stack, __assign({ alignItems: "center", py: 4, spacing: 2 }, { children: [_jsx(CircularProgress, {}), _jsx(Typography, { children: "Validando seu contexto de autenticacao..." })] })) })));
    }
    if (isAuthenticated) {
        return _jsx(Navigate, { replace: true, to: getDefaultHomePath(role) });
    }
    return (_jsxs(Paper, __assign({ sx: {
            borderRadius: 6,
            overflow: "hidden",
        } }, { children: [_jsxs(Box, __assign({ sx: {
                    background: "linear-gradient(135deg, #0B234F 0%, #0E4DA4 100%)",
                    color: "#FFFFFF",
                    p: { xs: 3, md: 4 },
                } }, { children: [_jsx(Typography, __assign({ sx: {
                            letterSpacing: "0.18em",
                            opacity: 0.88,
                            textTransform: "uppercase",
                        }, variant: "overline" }, { children: content.eyebrow })), _jsx(Typography, __assign({ sx: { mt: 1.5 }, variant: "h3" }, { children: content.title })), _jsx(Typography, __assign({ sx: { maxWidth: 680, mt: 2, opacity: 0.92 } }, { children: content.description }))] })), _jsx(Box, __assign({ sx: { p: { xs: 3, md: 4 } } }, { children: _jsxs(Stack, __assign({ spacing: 2.5 }, { children: [profileError ? (_jsx(Typography, __assign({ color: "error" }, { children: profileError }))) : null, actionError ? (_jsx(Typography, __assign({ color: "error" }, { children: actionError }))) : null, _jsx(Typography, __assign({ color: "text.secondary" }, { children: content.helper })), _jsxs(Stack, __assign({ direction: { xs: "column", sm: "row" }, spacing: 1.5 }, { children: [_jsx(Button, __assign({ disabled: submitting, endIcon: submitting ? (_jsx(CircularProgress, { color: "inherit", size: 18 })) : (_jsx(ArrowOutwardRoundedIcon, {})), onClick: function () { return void handleAction(); }, variant: "contained" }, { children: content.actionLabel })), _jsx(Button, __assign({ component: RouterLink, to: "/", variant: "outlined" }, { children: "Voltar para consultas" }))] }))] })) }))] })));
};
export var LoginPage = function () { return _jsx(SmartpassActionPage, { mode: "login" }); };
export var RegisterPage = function () { return _jsx(SmartpassActionPage, { mode: "register" }); };
export var MagicLinkPage = function () {
    var navigate = useNavigate();
    var _a = useAuth(), initialized = _a.initialized, isAuthenticated = _a.isAuthenticated, isLoadingAuth = _a.isLoadingAuth, role = _a.role;
    useEffect(function () {
        if (!initialized || isLoadingAuth) {
            return;
        }
        navigate(isAuthenticated ? getDefaultHomePath(role) : "/login", {
            replace: true,
        });
    }, [initialized, isAuthenticated, isLoadingAuth, navigate, role]);
    return (_jsxs(Paper, __assign({ sx: {
            borderRadius: 6,
            overflow: "hidden",
        } }, { children: [_jsxs(Box, __assign({ sx: {
                    background: "linear-gradient(135deg, #0B234F 0%, #0E4DA4 100%)",
                    color: "#FFFFFF",
                    p: { xs: 3, md: 4 },
                } }, { children: [_jsx(Typography, __assign({ sx: {
                            letterSpacing: "0.18em",
                            opacity: 0.88,
                            textTransform: "uppercase",
                        }, variant: "overline" }, { children: "Transicao de autenticacao" })), _jsx(Typography, __assign({ sx: { mt: 1.5 }, variant: "h3" }, { children: "Redirecionando para o fluxo Smartpass" })), _jsx(Typography, __assign({ sx: { maxWidth: 680, mt: 2, opacity: 0.92 } }, { children: "A rota legada de magic link foi mantida apenas para compatibilidade. O acesso agora converge para o Smartpass e para o perfil local do ParticiPE." }))] })), _jsx(Box, __assign({ sx: { p: { xs: 3, md: 4 } } }, { children: _jsxs(Stack, __assign({ alignItems: "center", py: 2, spacing: 2 }, { children: [_jsx(CircularProgress, {}), _jsx(Typography, __assign({ color: "text.secondary" }, { children: "Aguarde enquanto o redirecionamento e concluido." }))] })) }))] })));
};
